<script setup lang="ts">
/** A form's error; at a limit of your own plan, with the way to Your plan. */
import DAlert from '../../design/components/DAlert.vue';

defineProps<{ message: string; atYourLimit: boolean }>();
/** Following the link (a dialog closes itself). */
defineEmits<{ navigate: [] }>();
</script>

<template>
  <DAlert tone="error"
    >{{ message }}
    <RouterLink v-if="atYourLimit" :to="{ name: 'plan' }" @click="$emit('navigate')"
      >See your plan</RouterLink
    ></DAlert
  >
</template>
